import actionTypes from '../actionTypes';
export default {
  socketState: data => dispatch => {
    dispatch({
      type: actionTypes.GLOBAL_SOCKET_STATE,
      payload: data
    });
  },
  offlineState: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.IS_OFFLINE,
      payload: data,
    })
  },
  toggleApp: data => dispatch => {
    dispatch({
      type: actionTypes.GLOBAL_MINIMIZE_APP,
      payload: data
    });
  },
  callState: data => dispatch => {
    dispatch({
      type: actionTypes.GLOBAL_CALL_STATE,
      payload: data
    });
  },
  tabState: data => dispatch => {
    dispatch({
      type: actionTypes.GLOBAL_TAB_STATE,
      payload: data
    });
  },
  userState: data => dispatch => {
    dispatch({
      type: actionTypes.GLOBAL_STATE,
      payload: data
    });
  },
  dynamicUpdate: data => dispatch => {
    // console.log('dataaaa',data)
    dispatch({
      type: actionTypes.GLOBAL_DYNAMIC_UPDATE,
      payload: data
    });
  }
};



// WEBPACK FOOTER //
// src/store/action/global.action.js